import { Partner, UsufructData } from 'types';
import { ContributionData } from '../types/ContributionData';

type CreateContributionsProps = {
  partners: Partner[];
  usufructDataByPartner: { [key: string]: UsufructData[] };
  societyActualSharesCount: number;
  totalAmount: number;
};

export const createContributions = ({
  partners,
  usufructDataByPartner,
  societyActualSharesCount,
  totalAmount,
}: CreateContributionsProps): ContributionData[] =>
  partners.map((partner: Partner) => {
    const usufructData = usufructDataByPartner[partner._id] || [];

    const usufructSharesCount = usufructData.reduce((acc, data) => {
      const sharesCount = (data.sharesCount * data.percentage) / 100 || 0;
      return acc + (data.isMainCoOwner ? -sharesCount : sharesCount);
    }, 0);

    const partnerSharesCount =
      (partner.sharesCount?.actual || 0) + usufructSharesCount;

    const ndPercent =
      ((partner.sharesCount?.actual || 0) / societyActualSharesCount) * 100 ||
      0;

    const ndPercentWithUsufruct =
      ((partnerSharesCount || 0) / societyActualSharesCount) * 100 || 0;

    const toPerceive = (totalAmount * ndPercentWithUsufruct) / 100 || 0;

    return {
      partnerName: partner?.name,
      ndPercent,
      toPerceive,
      usufructData,
    };
  });
